// ✅ ProductDetail.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import products from "./products";

function ProductDetail({ addToCart }) {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));
  const [selectedSize, setSelectedSize] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(product?.images[0]);

  if (!product) return <div>Product not found</div>;

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert("Please select a size.");
      return;
    }

    addToCart({
      ...product,
      selectedSize,
      quantity,
      images: product.images // ✅ ensure images go with cart item
    });
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: "300px" }}>
          <img
            src={selectedImage}
            alt={product.name}
            style={{ width: "100%", marginBottom: "1rem" }}
          />
          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            {product.images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`${product.name} ${idx + 1}`}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  cursor: "pointer",
                  border: selectedImage === img ? "2px solid black" : "1px solid #ccc",
                }}
                onClick={() => setSelectedImage(img)}
              />
            ))}
          </div>
        </div>

        <div style={{ flex: 1, minWidth: "300px" }}>
          <h1>{product.name}</h1>
          <p><strong>£{product.price.toFixed(2)}</strong></p>

          {/* Product Description */}
          {product.description && product.description.intro && (
            <>
              <p>{product.description.intro}</p>
              <ul>
                {product.description.bullets.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </>
          )}

          <label>
            Size:
            <select
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
              style={{ marginLeft: "1rem" }}
            >
              <option value="">Select size</option>
              {["S", "M", "L", "XL", "2XL", "3XL"].map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </label>

          <div style={{ marginTop: "1rem" }}>
            Quantity:
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
              min="1"
              style={{ marginLeft: "1rem", width: "60px" }}
            />
          </div>

          <button
            onClick={handleAddToCart}
            style={{
              marginTop: "1.5rem",
              padding: "0.75rem 1.5rem",
              backgroundColor: "black",
              color: "white",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
